import React from 'react'

const getSeoFriendlyProps = alt =>
  alt
    ? {
        role: 'img',
        'aria-label': alt,
        title: alt
      }
    : {}

const SeoBackgroundImage = ({ alt, imgUrl, className }) => (
  <div className={className} style={{ backgroundImage: `url(${imgUrl})` }} {...getSeoFriendlyProps(alt)} />
)

export default SeoBackgroundImage
